"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const React = require("react");
const src_1 = require("@rover/ts-bootstrap/dist/src");
class PopoverTextRadioButtonComponent extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            onHoverName: '',
        };
        this.handleHover = this.handleHover.bind(this);
    }
    handleHover(onHoverName) {
        this.setState({
            onHoverName,
        });
    }
    render() {
        const { device, onClick, options, selectedTapOption } = this.props;
        return (React.createElement("div", { style: {
                display: 'flex',
                width: '100%',
                flexDirection: 'column',
                justifyContent: 'space-evenly',
            } }, Object.keys(options).map((name, index) => (React.createElement("div", { key: index, style: {
                padding: device !== 'Mobile' ? '0 16px' : '0 24px',
                background: this.state.onHoverName === name && device !== 'Mobile' ? src_1.beige : src_1.white,
            } },
            React.createElement("div", { style: {
                    display: 'flex',
                    height: device !== 'Mobile' ? 55 : 71,
                    background: this.state.onHoverName === name && device !== 'Mobile' ? src_1.beige : src_1.white,
                    justifyContent: 'space-between',
                    alignItems: 'center',
                }, onMouseOver: () => this.handleHover(name), onClick: (e) => {
                    e.stopPropagation();
                    onClick(name);
                } },
                React.createElement(src_1.Text, { text: options[name], size: "medium" }),
                React.createElement(src_1.RadioButton, { selected: selectedTapOption === name, style: {
                        outerStyle: { height: 18, width: 18 },
                    } })),
            (index !== Object.keys(options).length - 1 || device === 'Mobile') && (React.createElement("div", { style: {
                    height: 1,
                    background: src_1.titanium,
                } })))))));
    }
}
exports.default = PopoverTextRadioButtonComponent;
